import { Injectable } from '@angular/core';
import { SmApiService } from 'common/services/core-services/sm-api.service';
import { API_URL } from 'common/constants/sm-constants';
import { SystemService } from 'common/services/core-services/system.service';
import {
  GridModel,
  GridParams,
  GridPostParams,
} from 'common/models/utility-models/list-utility.model';
import { DashboardListingModel } from 'common/models/page-models/dashboard/dashboard-grid-model';
import { DashboardModel } from 'common/models/page-models/dashboard/dashboard-data-model';
import { DashboardGridPostParams } from 'common/models/page-models/dashboard/dashboard-grid-params';
import { DashboardChartsModel } from 'common/models/page-models/dashboard/dashboard-charts-model';
// import Highcharts, { charts, color } from "highcharts";
import * as Highcharts from 'highcharts';
import HighchartsMore from 'highcharts/highcharts-more';
import { style } from '@angular/animations';
import { GridDataService } from '../base-data-services/grid-data.service';
// import Drilldown from 'highcharts/modules/drilldown';

// Drilldown(Highcharts);
HighchartsMore(Highcharts);
@Injectable({
  providedIn: 'root',
})
export class DashboardDataService extends GridDataService<
  DashboardListingModel,
  DashboardModel
> {
  constructor(
    http: SmApiService,
    protected override ss: SystemService,
  ) {
    super(API_URL.getDashboardData, http, ss);
  }

  createInstance(): DashboardListingModel {
    return new DashboardListingModel();
  }

  getDeleteUrl() {
    return '';
  }

  getGridParams(param): GridPostParams {
    return new DashboardGridPostParams();
  }

  override async createGridModel(
    apiRes: any,
    queryParam: GridParams,
    dataParam: string = 'detail',
    extraParam: string = '',
  ): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      try {
        const gridModel = new GridModel<any>();
        const gridData = this.transformDataModel(apiRes, dataParam);
        gridModel.originalModel = !gridData[dataParam]
          ? []
          : gridData[dataParam];
        gridModel.filterModel = gridModel.originalModel;

        let dataExtra;
        dataExtra = !apiRes[extraParam] ? [] : apiRes[extraParam];
        if (dataExtra.length > 0) {
          dataExtra = apiRes[extraParam].sort((a, b) => b.id - a.id);
        }

        if (extraParam) {
          gridModel.extraData = dataExtra;
        }
        gridModel.pageModel = gridModel.originalModel;
        gridModel.pages = [];
        gridModel.search_text = '';
        gridModel.selectedPage = queryParam.currentPage
          ? queryParam.currentPage
          : 1;
        gridModel.recordPerPage = queryParam.recordPerPage
          ? queryParam.recordPerPage
          : 8;
        gridModel.totalRecords = gridModel.originalModel.length;
        gridModel.pageModel = gridModel.originalModel;
        gridModel.pages = [];
        gridModel.chartsData = this.prepareChartsData(gridModel.originalModel);
        resolve(gridModel);
      } catch (err) {
        const gridModel = new GridModel<any>();
        const gridData = this.transformDataModel(apiRes, dataParam);
        gridModel.originalModel = !gridData[dataParam]
          ? []
          : gridData[dataParam];
        gridModel.filterModel = gridModel.originalModel;
        reject('Oops! Something went wrong while loading the dashboard.');
      }
    });
  }

  override transformDataModel(data: any[], param: any) {
    super.transformDataModel(data, param);
    if (data.hasOwnProperty(param)) {
      data[param]['mentorsTotalCount'] =
        data[param].mentorCount.totalMentorCount;
    } else {
      this.ss.showError('No analytics found');
    }
    return data;
  }

  override modifyGridPostParams(queryParams) {
    let payload = this.getGridParams(queryParams);
    return payload;
  }

  override prepareChartsData(apiData) {
    const chartsModel = new DashboardChartsModel();

    //Students Dashboard Charts

    const stateNameShortFormMap = {
      'Andhra Pradesh': 'AP',
      'Arunachal Pradesh': 'AR',
      Assam: 'AS',
      Bihar: 'BR',
      Chhattisgarh: 'CG',
      Goa: 'GA',
      Gujarat: 'GJ',
      Haryana: 'HR',
      'Himachal Pradesh': 'HP',
      Jharkhand: 'JH',
      Karnataka: 'KA',
      Kerala: 'KL',
      'Madhya Pradesh': 'MP',
      Maharashtra: 'MH',
      Manipur: 'MN',
      Meghalaya: 'ML',
      Mizoram: 'MZ',
      Nagaland: 'NL',
      Odisha: 'OR',
      Punjab: 'PB',
      Rajasthan: 'RJ',
      Sikkim: 'SK',
      'Tamil Nadu': 'TN',
      Telangana: 'TG',
      Tripura: 'TR',
      'Uttar Pradesh': 'UP',
      Uttarakhand: 'UK',
      'West Bengal': 'WB',
      'Jammu and Kashmir': 'J & K',
      'New Delhi': 'Delhi',
      Pondicherry: 'PY',
      'Daman and Diu': 'DD',
      Chandigarh: 'CH',
      Lakshadweep: 'LD',
      Ladakh: 'LA',
      Puducherry: 'PY',
      'Andaman and Nicobar': 'AB',
    };

    chartsModel.recentUpcomingAssignmentList =
      apiData.recentUpcomingAssignmentList;
    chartsModel.recentlyAddedMentorCount = apiData.recentlyAddedMentorCount;

    // if (apiData.state_wise_student_count.length > 0) {
    const stateChartData = apiData.state_wise_student_count.map((state) => {
      return {
        name: state.stateName,
        value: parseInt(state.state_wise_student_count),
      };
    });

    const hasSingleState = stateChartData.length === 1;

    chartsModel.studentStateChart = {
  chart: {
    type: 'packedbubble',
    height: '320px',
    marginLeft: 20,
    marginRight: 20,
    animation: false,
    style: {
      fontSize: '17px',
    },
  },
  title: {
    text: 'State-wise Student Count Distribution',
    align: 'left',
  },
  tooltip: {
    useHTML: true,
    pointFormat: '<b>{point.name}:</b> {point.value} students',
  },
  plotOptions: {
    packedbubble: {
      animation: false,
      minSize: hasSingleState ? '45%' : '90%',
      maxSize: hasSingleState ? '65%' : '140%',
      zMin: 0,
      zMax: 700,
      layoutAlgorithm: {
        splitSeries: !hasSingleState,
        gravitationalConstant: hasSingleState ? 0.03 : 0.02,
        bubblePadding: 8,
        maxIterations: 200,
      },
      dataLabels: {
        enabled: true,
        formatter: function (this: Highcharts.PointLabelObject) {
          return stateNameShortFormMap[this.point.name] || this.point.name;
        },
        style: {
          color: 'black',
          textOutline: 'none',
          fontWeight: 'normal',
        },
      },
      colorByPoint: true,
      states: {
        hover: {
          enabled: false,
          halo: { size: 0 },
          marker: { enabled: false },
        },
      },
    },
    series: {
      animation: false,
    },
  },
  series: [
    {
      name: 'States',
      data: stateChartData,
      animation: false,
    },
  ],
};

    const batchData = apiData.batch_wise_student_count.map((item) => [
      item.batch_number, // Use full batch name
      Number(item.batch_wise_student_count),
    ]);

    chartsModel.studentBatchChart = {
      chart: {
        type: 'column',
        height: 320, // Increased height to accommodate rotated/multi-line labels
        // marginBottom: 80,
        backgroundColor: '#f0f0f0',
      },
      title: {
        text: `Student Batch Wise Analysis <br>Total: ${apiData.studentCount} Students`,
        style: {
          fontSize: '17px', // Adjust the font size here
        },
      },
      xAxis: {
        type: 'category',
        labels: {
          rotation: -45, // Rotate labels for better spacing
          style: {
            fontSize: '10px',
            fontFamily: 'Verdana, sans-serif',
          },
          useHTML: true, // Allow HTML for multi-line labels
          // formatter: function () {
          //   const label
          //    = this.value;
          //   const maxLength = 15; // Define a threshold for splitting labels
          //   if (label.length > maxLength) {
          //     const splitIndex = Math.ceil(label.length / 2);
          //     return (
          //       label.substring(0, splitIndex) +
          //       "<br/>" +
          //       label.substring(splitIndex)
          //     );
          //   }
          //   return label;
          // },
          formatter: (
            context: Highcharts.AxisLabelsFormatterContextObject,
          ): string => {
            const label = context.value as string;
            const maxLength = 15;
            if (label.length > maxLength) {
              const splitIndex = Math.ceil(label.length / 2);
              return (
                label.substring(0, splitIndex) +
                '<br/>' +
                label.substring(splitIndex)
              );
            }
            return label;
          },
        },
      },
      yAxis: {
        min: 0,
        title: {
          text: 'Number of Students',
        },
      },
      legend: {
        enabled: false,
      },
      tooltip: {
        headerFormat: `<span style="font-size: 10px">{point.key}</span><br/>`,
        pointFormat: 'Students: <b>{point.y:.0f}</b>',
      },
      series: [
        {
          name: 'Batch',
          colorByPoint: true,
          groupPadding: 0.1, // Slight padding between columns
          data: batchData,
          dataLabels: {
            enabled: false, // Disable data labels on columns to reduce clutter
            // If you want to enable them, consider formatting them appropriately
          },
          colors: [
            '#9b20d9',
            '#9215ac',
            '#861ec9',
            '#7a17e6',
            '#7010f9',
            '#691af3',
            '#6225ed',
            '#5b30e7',
            '#533be1',
            '#4c46db',
            '#4551d5',
            '#3e5ccf',
            '#3667c9',
            '#2f72c3',
            '#277dbd',
            '#1f88b7',
            '#1693b1',
            '#0a9eaa',
            '#03c69b',
            '#00f194',
          ],
        },
      ],
      plotOptions: {
        column: {
          // Optional: Add some shadow or border for better aesthetics
          shadow: true,
          borderWidth: 1,
          borderColor: '#FFFFFF',
        },
      },
      responsive: {
        rules: [
          {
            condition: {
              maxWidth: 600,
            },
            chartOptions: {
              xAxis: {
                labels: {
                  rotation: -90,
                  style: {
                    fontSize: '9px',
                  },
                },
              },
            },
          },
        ],
      },
    };
    // }

    // if (apiData.region_wise_student_count.length > 0) {
    // const regionData = apiData.region_wise_student_count.map((region) => {
    //   return {
    //     name: region.region,
    //     y: Number(region.region_wise_student_count),
    //   };
    // });

    const regionData = apiData.region_wise_student_count
      .filter((region) => region.region !== null) // Exclude regions with null
      .map((region) => {
        return {
          name: region.region,
          y: Number(region.region_wise_student_count),
        };
      });

    chartsModel.studentRegionChart = {
      chart: {
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        type: 'pie',
        width: 350, // Adjust chart width
        height: 300, // Adjust chart height
      },
      title: {
        text: 'Student Distribution Region Wise',
        align: 'left',
        style: {
          fontSize: '17px', // Adjust the font size here
        },
      },
      tooltip: {
        pointFormat: '{series.name}: <b>{point.y:.0f}</b>',
      },
      accessibility: {
        point: {
          valueSuffix: '',
        },
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: {
            enabled: false,
          },

          colors: ['#73877b', '#e07b57', '#e87a8a', '#d4a73a'],
          showInLegend: true,
        },
      },
      series: [
        {
          name: 'Regions',
          colorByPoint: true,
          data: regionData,
        },
      ],
    };
    // }

    // if (apiData.status_wise_student_count.length > 0) {
    const statusData = apiData.status_wise_student_count.map((status) => {
      return {
        name: status.status_text,
        y: Number(status.status_wise_student_count),
      };
    });

    chartsModel.studentStatusChart = {
      chart: {
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        type: 'pie',
        width: 450, // Adjust chart width
        height: 300, // Adjust chart height
      },
      title: {
        text: 'Student Distribution Status Wise',
        align: 'left',
        style: {
          fontSize: '17px', // Adjust the font size here
        },
      },
      tooltip: {
        pointFormat: '{series.name}: <b>{point.y:.0f}</b>',
      },
      accessibility: {
        point: {
          valueSuffix: '',
        },
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: {
            enabled: false,
          },

          colors: ['#FFE6E6', '#E1AFD1', '#AD88C6', '#7469B6'],
          showInLegend: true,
        },
      },
      series: [
        {
          name: 'Status',
          colorByPoint: true,
          data: statusData,
        },
      ],
    };
    // }

    // if (apiData.gender_wise_count.length > 0) {
    const genderData = apiData.gender_wise_count.map((item) => ({
      name: item.gender.charAt(0).toUpperCase() + item.gender.slice(1),
      y: parseInt(item.gender_wise_count, 10),
    }));

    chartsModel.studentGenderChart = {
      chart: {
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        type: 'pie',
        width: 450, // Adjust chart width
        height: 300, // Adjust chart height
      },
      title: {
        text: 'Student Distribution Gender Wise',
        align: 'left',
        style: {
          fontSize: '17px', // Adjust the font size here
        },
      },
      tooltip: {
        pointFormat: '{series.name}: <b>{point.y:.0f}</b>',
      },
      accessibility: {
        point: {
          valueSuffix: '',
        },
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: {
            enabled: false,
          },
          colors: ['#d5a6bd', '#6fa8dc'],
          showInLegend: true,
        },
      },
      series: [
        {
          name: 'Gender',
          colorByPoint: true,
          data: genderData,
        },
      ],
    };
    //  }

    //Assignments
    // if (apiData.typeWiseAssignmentDetail.length > 0) {

    const typeMap = new Map<string, string>();

    apiData.typeWiseAssignmentDetail.forEach((item) => {
      if (!typeMap.has(item.type)) {
        typeMap.set(item.type, item.invitedStudentCount);
      }
    });

    // Extract the first three unique types and their counts
    const firstThreeTypes = Array.from(typeMap.entries()).slice(0, 3);

    // Update the chartsModel with the first three types and their counts
    firstThreeTypes.forEach(([type, count]) => {
      chartsModel.typeWiseAssignmentDetailCount.push({
        type,
        invitedStudentCount: count,
      });
    });

    // assignment pie chart
    let firstThreeAssignments: any = [];
    if (apiData.typeWiseAssignmentDetail.length >= 3) {
      firstThreeAssignments = apiData.typeWiseAssignmentDetail.slice(0, 3);
    } else {
      firstThreeAssignments = apiData.typeWiseAssignmentDetail;
    }

    const assignmentSkillChartFirst = firstThreeAssignments[0] || {};
    const assignmentSkillChartSecond = firstThreeAssignments[1] || {};
    const assignmentSkillChartThird = firstThreeAssignments[2] || {};

    chartsModel.assignmentSkillChartFirst = {
      chart: {
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        type: 'pie',
        width: 350, // Adjust chart width
        height: 300, // Adjust chart height
      },
      title: {
        text: assignmentSkillChartFirst.type,
        align: 'left',
      },
      tooltip: {
        pointFormat: '{series.name}: <b>{point.y:.0f}</b>',
      },
      accessibility: {
        point: {
          valueSuffix: '',
        },
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: {
            enabled: false,
          },
          showInLegend: true,
        },
      },
      series: [
        {
          name: assignmentSkillChartFirst.type,
          colorByPoint: true,
          data: [
            {
              name: 'Attended Student',
              y: parseInt(assignmentSkillChartFirst.attendedStudentCount),
              color: '#E8C5E5',
            },
            {
              name: 'Not Attended Student',
              y: parseInt(assignmentSkillChartFirst.notAttendedStudentCount),
              color: '#91DDCF',
            },
          ],
        },
      ],
    };

    chartsModel.assignmentSkillChartSecond = {
      chart: {
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        type: 'pie',
        width: 350, // Adjust chart width
        height: 300, // Adjust chart height
      },
      title: {
        text: assignmentSkillChartSecond.type,
        align: 'left',
      },
      tooltip: {
        pointFormat: '{series.name}: <b>{point.y:.0f}</b>',
      },
      accessibility: {
        point: {
          valueSuffix: '',
        },
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: {
            enabled: false,
          },
          showInLegend: true,
        },
      },
      series: [
        {
          name: assignmentSkillChartSecond.type,
          colorByPoint: true,
          data: [
            {
              name: 'Attended Student',
              y: parseInt(assignmentSkillChartSecond.attendedStudentCount),
              color: '#AD88C6',
            },
            {
              name: 'Not Attended Student',
              y: parseInt(assignmentSkillChartSecond.notAttendedStudentCount),
              color: '#E1AFD1',
            },
          ],
        },
      ],
    };

    chartsModel.assignmentSkillChartThird = {
      chart: {
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        type: 'pie',
        width: 350, // Adjust chart width
        height: 300, // Adjust chart height
      },
      title: {
        text: assignmentSkillChartThird.type,
        align: 'left',
      },
      tooltip: {
        pointFormat: '{series.name}: <b>{point.y:.0f}</b>',
      },
      accessibility: {
        point: {
          valueSuffix: '',
        },
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: {
            enabled: false,
          },
          showInLegend: true,
        },
      },
      series: [
        {
          name: assignmentSkillChartThird.type,
          colorByPoint: true,
          data: [
            {
              name: 'Attended Student',
              y: parseInt(assignmentSkillChartThird.attendedStudentCount),
              color: '#F3D7CA',
            },
            {
              name: 'Not Attended Student',
              y: parseInt(assignmentSkillChartThird.notAttendedStudentCount),
              color: '#E6A4B4',
            },
          ],
        },
      ],
    };

    //Mentors

    const isDocUploaded: any[] = apiData.batchwiseMentoringDocUploads.filter(
      (doc) => doc.total_docs_uploaded.length !== '0',
    );
    const isDocNotUploaded: any[] = apiData.batchwiseMentoringDocUploads.filter(
      (doc) => doc.total_docs_uploaded === '0',
    );

    chartsModel.documentsNotUploadedData = isDocNotUploaded;

    const mentorData = [
      {
        name: 'Total Mentor Assigned',
        y: parseInt(apiData.mentorCount.totalMentorAssignedCount),
        color: '#ed8300',
      },
      {
        name: 'Total Mentor Not Assigned',
        y: parseInt(apiData.mentorCount.totalMentorNotAssignedCount),
        color: '#f8cd84',
      },
    ];

    const menteeData = [
      {
        name: 'Total Student Assigned to Mentor',
        y: parseInt(apiData.menteeCount.totalStudentMentorAssignedCount),
        color: '#a8e6cf',
      },
      {
        name: 'Total Student Not Assigned to Mentor',
        y: parseInt(apiData.menteeCount.totalStudentMentorNotAssignedCount),
        color: '#dcc6e0',
      },
    ];

    const batchWiseMentoringDocData = [
      {
        name: 'Mentor Assigned',
        data: apiData.batchwiseMentorAssignedToStudent.map((batch) =>
          parseInt(batch.mentor_assigned_count),
        ),
        color: '#727CF5',
      },
      {
        name: 'Mentor Not Assigned',
        data: apiData.batchwiseMentorAssignedToStudent.map((batch) =>
          parseInt(batch.mentor_not_assigned_count),
        ),
        color: '#000000',
      },
    ];

    const uploadDocData = {};

    isDocUploaded.forEach((doc) => {
      const batchName = doc.batch_name || 'Unknown';

      if (!uploadDocData[batchName]) {
        uploadDocData[batchName] = {
          year1_count: 0,
          year2_count: 0,
          year3_count: 0,
          year4_count: 0,
        };
      }
      uploadDocData[batchName].year1_count += parseInt(doc.year1_count);
      uploadDocData[batchName].year2_count += parseInt(doc.year2_count);
      uploadDocData[batchName].year3_count += parseInt(doc.year3_count);
      uploadDocData[batchName].year4_count += parseInt(doc.year4_count);
    });

    const seriesData = [
      {
        name: 'Year 1',
        data: Object.values(uploadDocData).map(
          (batch: any) => batch.year1_count,
        ),
        stack: 'Total',
        color: '#fadadd',
      },
      {
        name: 'Year 2',
        data: Object.values(uploadDocData).map(
          (batch: any) => batch.year2_count,
        ),
        stack: 'Total',
        color: '#a8e6cf',
      },
      {
        name: 'Year 3',
        data: Object.values(uploadDocData).map(
          (batch: any) => batch.year3_count,
        ),
        stack: 'Total',
        color: '#dcc6e0',
      },
      {
        name: 'Year 4',
        data: Object.values(uploadDocData).map(
          (batch: any) => batch.year4_count,
        ),
        stack: 'Total',
        color: '#ffd3b6',
      },
    ];

    //Feedback chart assigned
    const filteredData = apiData.feedback_assigned_student_batchwise.filter(
      (item) => {
        const count = parseInt(item.feedbackAssignedToStudentCount, 10);
        return !isNaN(count) && count > 0;
      },
    );

    const transformedfeedBackData = filteredData.map((item) =>
      parseInt(item.feedbackAssignedToStudentCount, 10),
    );
    const feedbackCategories = filteredData.map((item) => item.batch_number);

    //Feedback chart uploaded

    const feedbackfilteredData =
      apiData.feedback_uploaded_student_batchwise.filter((item) => {
        const count = parseInt(item.feedbackSubmittedStudentCount, 10);
        return !isNaN(count) && count > 0;
      });

    const feedbacktransformedData = feedbackfilteredData.map((item) =>
      parseInt(item.feedbackSubmittedStudentCount, 10),
    );
    const feedbackUploadedCategories = feedbackfilteredData.map(
      (item) => item.batch_number,
    );

    chartsModel.mentorChart = {
      chart: {
        type: 'pie',
        height: 300,
      },
      title: {
        text: 'Mentor Distribution',
      },
      tooltip: {
        valueSuffix: '',
      },
      plotOptions: {
        series: {
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: [
            {
              enabled: true,
              distance: 20,
            },
            {
              enabled: true,
              distance: -40,
              format: '{point.percentage:.0f}',
              style: {
                fontSize: '1.2em',
                textOutline: 'none',
                opacity: 0.7,
              },
              filter: {
                operator: '>',
                property: 'percentage',
                value: 10,
              },
            },
          ],
          showInLegend: true,
        },
      },
      series: [
        {
          name: 'Count',
          colorByPoint: true,
          data: mentorData,
        },
      ],
    };

    chartsModel.menteeChart = {
      chart: {
        type: 'pie',
        height: 300,
      },
      title: {
        text: 'Mentee Distribution',
      },
      tooltip: {
        valueSuffix: '',
      },
      plotOptions: {
        series: {
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: [
            {
              enabled: true,
              distance: 20,
            },
            {
              enabled: true,
              distance: -40,
              format: '{point.percentage:.1f}',
              style: {
                fontSize: '1.2em',
                textOutline: 'none',
                opacity: 0.7,
              },
              filter: {
                operator: '>',
                property: 'percentage',
                value: 10,
              },
            },
          ],
          showInLegend: true,
        },
      },
      series: [
        {
          name: 'Count',
          colorByPoint: true,
          data: menteeData,
        },
      ],
    };

    chartsModel.batchWiseMentoringDocChart = {
      chart: {
        type: 'column',
        height: 350,
        backgroundColor: '#f4f4f4', // Light background for contrast
        style: {
          fontFamily: 'Arial, sans-serif', // Consistent font family
        },
        scrollablePlotArea: {
          minWidth: 600,
          scrollPositionX: 0,
        },
      },
      title: {
        text: 'Batch-wise Mentor Distribution',
        align: 'left',
        style: {
          fontSize: '18px',
          fontWeight: 'bold',
          color: '#333',
        },
      },
      xAxis: {
        categories: apiData.batchwiseMentorAssignedToStudent.map(
          (batch) => batch.batch_name,
        ),
        labels: {
          rotation: -45,
          style: {
            fontSize: '12px',
            fontWeight: 'normal',
            color: '#666',
          },
          // formatter: function () {
          //   let label = this.value;
          //   return label.length > 10 ? label.substring(0, 10) + "..." : label;
          // },

          formatter: (
            context: Highcharts.AxisLabelsFormatterContextObject,
          ): string => {
            const label = context.value as string;
            return label.length > 10 ? label.substring(0, 10) + '...' : label;
          },
        },
        gridLineWidth: 0, // Optional: remove grid lines for a cleaner look
      },
      yAxis: {
        allowDecimals: false,
        min: 0,
        title: {
          text: 'Count',
          style: {
            fontSize: '14px',
            fontWeight: 'bold',
            color: '#666',
          },
        },
        labels: {
          style: {
            fontSize: '12px',
            color: '#666',
          },
        },
        gridLineWidth: 1,
        gridLineColor: '#e1e1e1', // Light grid line color
      },
      tooltip: {
        useHTML: true,
        backgroundColor: '#fff',
        borderColor: '#ccc',
        borderRadius: 5,
        borderWidth: 1,
        // formatter: function () {
        //   return `
        //           <b>${this.x}</b><br/>
        //           ${this.series.name}: <b>${this.y}</b><br/>
        //           Total: <b>${this.point.stackTotal}</b>
        //         `;
        // },
      },
      plotOptions: {
        column: {
          stacking: 'normal',
          dataLabels: {
            enabled: false, // Data labels are disabled
          },
          borderWidth: 1,
          borderColor: '#fff', // White border for columns
          shadow: true, // Add shadow for better depth
        },
      },
      legend: {
        layout: 'horizontal',
        align: 'center',
        verticalAlign: 'top',
        floating: true,
        backgroundColor:
          Highcharts.defaultOptions.legend.backgroundColor || 'white',
        borderColor: '#CCC',
        borderWidth: 1,
        shadow: false,
        y: 25, // Adjust to move legend down or up
      },
      series: batchWiseMentoringDocData,
      responsive: {
        rules: [
          {
            condition: {
              maxWidth: 600,
            },
            chartOptions: {
              xAxis: {
                labels: {
                  rotation: -90,
                  style: {
                    fontSize: '10px',
                  },
                },
              },
            },
          },
        ],
      },
    };

    chartsModel.batchwiseMentoringDocUploadsChart = {
      chart: {
        type: 'column',
        height: 320,
      },
      title: {
        text: 'Mentoring Doc Uploads, grouped by batches',
        align: 'left',
      },
      xAxis: {
        categories: Object.keys(uploadDocData),
        labels: {
          rotation: -45,
          style: {
            fontSize: '12px',
            fontWeight: 'normal',
            color: '#666',
          },
          // formatter: function () {
          //   let label = this.value;
          //   return label.length > 10 ? label.substring(0, 10) + "..." : label;
          // },
          formatter: (
            context: Highcharts.AxisLabelsFormatterContextObject,
          ): string => {
            const label = context.value as string;
            return label.length > 10 ? label.substring(0, 10) + '...' : label;
          },
        },
        gridLineWidth: 0,
      },
      yAxis: {
        allowDecimals: false,
        min: 0,
        title: {
          text: 'Document Count',
        },
      },
      tooltip: {
        pointFormat:
          '<b>{point.stack}</b><br/>{series.name}: {point.y}<br/>Total: {point.stackTotal}',
      },
      plotOptions: {
        column: {
          stacking: 'normal',
        },
      },
      series: seriesData,
    };

    // if (filteredData.length === 0) {
    //   // Set the message for no data
    //   chartsModel.feedbackAssignedBatchWise = {
    //     title: {
    //       text: "No Data Found",
    //       style: {
    //         color: "#4a235a",
    //         fontWeight: "bold",
    //         fontSize: "15px",
    //       },
    //     },
    //     series: [],
    //     // Optionally, you can configure other chart options here if needed
    //   };
    // } else {
    // Configure the chart with filtered data
    chartsModel.feedbackAssignedBatchWise = {
      chart: {
        type: 'column',
        backgroundColor: '#f9f9f9', // Light background for contrast
        borderRadius: 10, // Rounded corners for the chart
        height: 325,
      },
      title: {
        text: 'Feedback Assigned To Student Batchwise',
        style: {
          color: '#000000', // Deep purple title color
          fontWeight: 'bold',
          fontSize: '15px',
        },
      },
      xAxis: {
        categories: feedbackCategories, // Use transformed categories
        crosshair: true,
        labels: {
          style: {
            color: '#4a235a', // Matching the title color for consistency
            fontWeight: 'bold',
          },
        },
        lineColor: '#4a235a', // Axis line color
        tickColor: '#4a235a', // Tick marks color
      },
      yAxis: {
        min: 0,
        title: {
          text: 'Feedback Count',
          style: {
            color: '#4a235a',
            fontWeight: 'bold',
          },
        },
        labels: {
          style: {
            color: '#4a235a',
            fontWeight: 'bold',
          },
        },
        gridLineColor: '#dcdcdc', // Subtle grid lines
      },
      series: [
        {
          name: 'Feedback',
          data: transformedfeedBackData, // Use transformed data
          colorByPoint: true,
          colors: [
            '#DCC6E0', // Purple
          ],
        },
      ],
      plotOptions: {
        column: {
          borderWidth: 0, // Removing border for a clean look
          dataLabels: {
            enabled: true,
            format: '{point.y:,.0f}',
            style: {
              color: '#4a235a', // Dark color for readability
              fontWeight: 'bold',
            },
          },
        },
      },
      tooltip: {
        backgroundColor: 'rgba(74, 35, 90, 0.85)', // Semi-transparent purple
        style: {
          color: '#ffffff', // White text for contrast
          fontWeight: 'bold',
        },
        borderColor: '#4a235a', // Border matches the chart's theme
        borderRadius: 10,
        borderWidth: 2,
      },
    };
    // }

    // if (feedbackfilteredData.length === 0) {
    //   // Set the message for no data
    //   chartsModel.feedbackUploadedBatchWise = {
    //     chart: {
    //       type: "column",
    //       backgroundColor: "#f9f9f9", // Light background for contrast
    //       borderRadius: 10, // Rounded corners for the chart
    //       height: 325,
    //     },
    //     title: {
    //       text: "No Data Found",
    //       style: {
    //         color: "#4a235a",
    //         fontWeight: "bold",
    //         fontSize: "15px",
    //       },
    //     },
    //     series: [],
    //     // Optionally, you can configure other chart options here if needed
    //   };
    // } else {
    // Configure the chart with filtered data
    chartsModel.feedbackUploadedBatchWise = {
      chart: {
        type: 'column',
        backgroundColor: '#f9f9f9', // Light background for contrast
        borderRadius: 10, // Rounded corners for the chart
        height: 325,
      },
      title: {
        text: 'Feedback Submitted by Batch',
        style: {
          color: '#000000', // Deep purple title color
          fontWeight: 'bold',
          fontSize: '15px',
        },
      },
      xAxis: {
        categories: feedbackUploadedCategories, // Use transformed categories
        crosshair: true,
        labels: {
          style: {
            color: '#4a235a', // Matching the title color for consistency
            fontWeight: 'bold',
          },
        },
        lineColor: '#4a235a', // Axis line color
        tickColor: '#4a235a', // Tick marks color
      },
      yAxis: {
        min: 0,
        title: {
          text: 'Number of Students',
          style: {
            color: '#4a235a',
            fontWeight: 'bold',
          },
        },
        labels: {
          style: {
            color: '#4a235a',
            fontWeight: 'bold',
          },
        },
        gridLineColor: '#dcdcdc', // Subtle grid lines
      },
      series: [
        {
          name: 'Students',
          data: feedbacktransformedData, // Use transformed data
          colorByPoint: true,
          colors: ['#FADADD'],
          pointWidth: 30, // Set the max width of the bars
        },
      ],
      plotOptions: {
        column: {
          borderWidth: 0, // Removing border for a clean look
          dataLabels: {
            enabled: true,
            format: '{point.y:,.0f}',
            style: {
              color: '#4a235a', // Dark color for readability
              fontWeight: 'bold',
            },
          },
          pointPadding: 0.1, // Adjust padding between bars
          groupPadding: 0.1, // Adjust padding between groups of bars
        },
      },
      tooltip: {
        backgroundColor: 'rgba(74, 35, 90, 0.85)', // Semi-transparent purple
        style: {
          color: '#ffffff', // White text for contrast
          fontWeight: 'bold',
        },
        borderColor: '#4a235a', // Border matches the chart's theme
        borderRadius: 10,
        borderWidth: 2,
      },
    };
    // }

    //Internship

    const internshipData = apiData.allInternshipDataCount || {};

    chartsModel.studentInternshipCount = {
      chart: {
        type: 'pie',
        height: 350,
        custom: {},
        events: {
          render() {
            const chart: any = this,
              series = chart.series[0];
            let customLabel = chart.options.chart.custom.label;

            if (!customLabel) {
              customLabel = chart.options.chart.custom.label = chart.renderer
                .label(
                  'Total<br/>' +
                    '<strong>' +
                    internshipData.totalInvitedStudent +
                    '</strong>',
                )
                .css({
                  color: '#000',
                  textAnchor: 'middle',
                })
                .add();
            }

            const x = series.center[0] + chart.plotLeft,
              y =
                series.center[1] +
                chart.plotTop -
                customLabel.attr('height') / 2;

            customLabel.attr({
              x,
              y,
            });
            // Set font size based on chart diameter
            customLabel.css({
              fontSize: `${series.center[2] / 12}px`,
            });
          },
        },
      },
      accessibility: {
        point: {
          valueSuffix: '',
        },
      },
      title: {
        text: 'Internship Type Breakdown',
        style: {
          fontSize: '17px', // Adjust the font size here
        },
      },
      tooltip: {
        pointFormat: '{point.name}: <b>{point.y}</b> ({point.percentage:.1f}%)',
      },
      legend: {
        enabled: true,
      },
      plotOptions: {
        series: {
          allowPointSelect: true,
          cursor: 'pointer',
          borderRadius: 8,
          dataLabels: [
            {
              enabled: true,
              distance: 20,
              format: '{point.name}',
            },
            {
              enabled: true,
              distance: -15,
              format: '{point.percentage:.0f}%',
              style: {
                fontSize: '0.9em',
              },
            },
          ],
          showInLegend: true,
        },
      },
      series: [
        {
          name: 'Internship',
          colorByPoint: true,
          innerSize: '75%',

          data: [
            {
              name: 'External Internship',
              y: parseInt(internshipData.totalExternalInternshipStudent),
              color: '#f2952f',
            },
            {
              name: 'Internal Internship',
              y: parseInt(internshipData.totalInternalInternshipStudent),
              color: '#389388',
            },
            {
              name: 'No Internship',
              y: parseInt(internshipData.noInternship),
              color: '#ffd2ce',
            },
          ],
        },
      ],
    };

    chartsModel.studentInternshipDetailsChart = {
      chart: {
        type: 'column',
        backgroundColor: '#f0f0f0',
        borderRadius: 10,
        height: 330,
        style: {
          fontFamily: 'Arial, sans-serif',
        },
      },
      title: {
        text: 'Internship Student Status Breakdown',
        style: {
          color: '#3c464b',
          fontSize: '17px',
        },
      },
      xAxis: {
        categories: ['Total Students'],
        labels: {
          style: {
            color: '#3c464b',
            fontSize: '12px',
          },
        },
      },
      yAxis: {
        min: 0,
        title: {
          text: 'Number of Students',
          style: {
            color: '#3c464b',
            fontSize: '12px',
          },
        },
        labels: {
          style: {
            color: '#3c464b',
            fontSize: '10px',
          },
        },
        gridLineColor: '#e6e6e6',
      },
      plotOptions: {
        column: {
          stacking: 'normal',
          dataLabels: {
            enabled: true,
            color: '#ffffff',
            style: {
              textOutline: 'none',
              fontWeight: 'bold',
            },
          },
          borderRadius: 3,
          borderWidth: 0,
          pointPadding: 0.1,
          groupPadding: 0.05,
        },
      },
      colors: [
        '#139f84', // Theme color 1 (Green)
        '#ff6f61', // Coral
        '#3c464b', // Theme color 2 (Dark Grey)
        '#6b5b95', // Purple
        '#feb236', // Orange
        '#d64161', // Crimson
        '#ff7b25', // Bright Orange
        '#45b8ac', // Teal
        '#ffcc5c', // Yellow
        '#88d8b0', // Light Green
      ],
      legend: {
        align: 'center',
        verticalAlign: 'bottom',
        layout: 'horizontal',
        itemStyle: {
          color: '#3c464b',
          fontSize: '10px', // Smaller font size for the legend
          fontWeight: 'normal',
        },
        itemHoverStyle: {
          color: '#139f84',
        },
        symbolHeight: 10,
        symbolWidth: 10,
      },
      series: [
        {
          name: 'Invited',
          data: [
            apiData.allInternshipDataCount !== null
              ? parseInt(apiData.allInternshipDataCount.totalInvitedStudent)
              : 0,
          ],
          color: '#139f84',
        },
        {
          name: 'Non-Invited',
          data: [
            apiData.allInternshipDataCount !== null
              ? parseInt(apiData.allInternshipDataCount.totalNotInvitedStudent)
              : 0,
          ],
          color: '#ff6f61',
        },
        {
          name: 'Available',
          data: [
            apiData.allInternshipDataCount !== null
              ? parseInt(
                  apiData.allInternshipDataCount
                    .totalAvailableAndAssignedStudent,
                ) +
                parseInt(
                  apiData.allInternshipDataCount
                    .totalAvailableButNotAssignedStudent,
                )
              : 0,
          ],
          stack: 'Invited',
          color: '#6b5b95',
        },
        {
          name: 'Not Available',
          data: [
            apiData.allInternshipDataCount !== null
              ? parseInt(
                  apiData.allInternshipDataCount.totalNotAvailableStudent,
                )
              : 0,
          ],
          stack: 'Invited',
          color: '#feb236',
        },
        {
          name: 'Not Responded',
          data: [
            apiData.allInternshipDataCount !== null
              ? parseInt(
                  apiData.allInternshipDataCount
                    .totalInvitedButNotRespondedStudent,
                )
              : 0,
          ],
          stack: 'Invited',
          color: '#d64161',
        },
        {
          name: 'Internship Assigned',
          data: [
            apiData.allInternshipDataCount !== null
              ? parseInt(
                  apiData.allInternshipDataCount
                    .totalAvailableAndAssignedStudent,
                )
              : 0,
          ],
          stack: 'Available',
          color: '#ff7b25',
        },
        {
          name: 'Not Assigned',
          data: [
            apiData.allInternshipDataCount !== null
              ? parseInt(
                  apiData.allInternshipDataCount
                    .totalAvailableButNotAssignedStudent,
                )
              : 0,
          ],
          stack: 'Available',
          color: '#45b8ac',
        },
        {
          name: 'Not Completed',
          data: [
            apiData.allInternshipDataCount !== null
              ? parseInt(
                  apiData.allInternshipDataCount.totalNotCompletedStudent,
                )
              : 0,
          ],
          stack: 'Internship Assigned',
          color: '#ffcc5c',
        },
        {
          name: 'Not Joined',
          data: [
            apiData.allInternshipDataCount !== null
              ? parseInt(apiData.allInternshipDataCount.totalNotJoinedStudent)
              : 0,
          ],
          stack: 'Internship Assigned',
          color: '#88d8b0',
        },
        {
          name: 'Completed',
          data: [
            apiData.allInternshipDataCount !== null
              ? parseInt(apiData.allInternshipDataCount.totalCompletedStudent)
              : 0,
          ],
          stack: 'Internship Assigned',
          color: '#3c464b',
        },
      ],
      annotations: [
        {
          labels: [
            {
              point: {
                x: 0,
                y: -10, // Positioning below the column
                xAxis: 0,
                yAxis: 0,
              },
              text: 'Invited: 68, Non-Invited: 740',
              style: {
                fontSize: '12px',
                color: '#3c464b',
              },
            },
            {
              point: {
                x: 0,
                y: -20,
                xAxis: 0,
                yAxis: 0,
              },
              text: 'Available: 44, Not Available: 7, Not Responded: 11',
              style: {
                fontSize: '12px',
                color: '#3c464b',
              },
            },
            {
              point: {
                x: 0,
                y: -30,
                xAxis: 0,
                yAxis: 0,
              },
              text: 'Internship Assigned: 35, Not Assigned: 6',
              style: {
                fontSize: '12px',
                color: '#3c464b',
              },
            },
            {
              point: {
                x: 0,
                y: -40,
                xAxis: 0,
                yAxis: 0,
              },
              text: 'Not Completed: 35, Not Joined: 20, Completed: 5',
              style: {
                fontSize: '12px',
                color: '#3c464b',
              },
            },
          ],
        },
      ],
    };

    //Applicant Data Chart

    const applicantData = apiData.ApplicantCategoryData[0];

    const transformedData = [
      parseInt(applicantData.appliedCount),
      parseInt(applicantData.deligenceCount),
      parseInt(applicantData.documentationCount),
      parseInt(applicantData.assessmentCount),
      parseInt(applicantData.interviewCount),
      parseInt(applicantData.homeVisitCount),
      parseInt(applicantData.ShortlistingCount),
      parseInt(applicantData.ShorlistedCount),
    ];

    chartsModel.applicantCategoryData = {
      chart: {
        type: 'column',
        backgroundColor: '#f9f9f9', // Light background for contrast
        borderRadius: 10, // Rounded corners for the chart
        height: 325,
      },
      title: {
        text: 'Applicant Progression by Stages',
        style: {
          color: '#000000', // Deep purple title color
          fontWeight: 'bold',
          fontSize: '20px',
        },
      },
      xAxis: {
        categories: [
          'Applied',
          'Deligence',
          'Documentation',
          'Assessment',
          'Interview',
          'Home Visit',
          'Shortlisting',
          'Shortlisted',
        ],
        crosshair: true,
        labels: {
          style: {
            color: '#4a235a', // Matching the title color for consistency
            fontWeight: 'bold',
          },
        },
        lineColor: '#4a235a', // Axis line color
        tickColor: '#4a235a', // Tick marks color
      },
      yAxis: {
        min: 0,
        title: {
          text: 'Number of Applicants',
          style: {
            color: '#4a235a',
            fontWeight: 'bold',
          },
        },
        labels: {
          style: {
            color: '#4a235a',
            fontWeight: 'bold',
          },
        },
        gridLineColor: '#dcdcdc', // Subtle grid lines
      },
      series: [
        {
          name: 'Applicants',
          data: transformedData,
          colorByPoint: true,
          colors: [
            '#7e57c2', // Purple
            '#ba68c8', // Lavender
            '#e57373', // Soft pink
            '#f06292', // Bright pink
            '#ab47bc', // Medium purple
            '#ce93d8', // Light lavender
            '#f48fb1', // Pale pink
            '#d1c4e9', // Very light purple
          ],
        },
      ],
      plotOptions: {
        column: {
          borderWidth: 0, // Removing border for a clean look
          dataLabels: {
            enabled: true,
            format: '{point.y:,.0f}',
            style: {
              color: '#4a235a', // Dark color for readability
              fontWeight: 'bold',
            },
          },
        },
      },
      tooltip: {
        backgroundColor: 'rgba(74, 35, 90, 0.85)', // Semi-transparent purple
        style: {
          color: '#ffffff', // White text for contrast
          fontWeight: 'bold',
        },
        borderColor: '#4a235a', // Border matches the chart's theme
        borderRadius: 10,
        borderWidth: 2,
      },
    };

    const applicantstateChartData = apiData.ApplicantStateData.map((state) => {
      return {
        name: state.stateName,
        value: parseInt(state.stateApplicantCount),
      };
    });

    chartsModel.applicantStateDataChart = {
      chart: {
        type: 'packedbubble',
        height: '320px', // Increased height for better spacing
        marginLeft: 20,
        marginRight: 20,
        style: {
          fontSize: '17px',
        },
      },
      title: {
        text: 'State-wise Applicant Count Distribution',
        align: 'left',
      },
      tooltip: {
        useHTML: true,
        pointFormat: '<b>{point.name}:</b> {point.value} applicants',
      },
      plotOptions: {
        packedbubble: {
          minSize: '100%',
          maxSize: '190%',
          zMin: 0,
          zMax: 700,
          layoutAlgorithm: {
            splitSeries: true,
            gravitationalConstant: 0.01,
            bubblePadding: 13,
            maxIterations: 1000,
          },
          dataLabels: {
            enabled: true,
            // formatter: function (this: Highcharts.Point) {

            //   //  return stateNameShortFormMap[this.point.name] || this.point.name;
            // },
            formatter: function (this: Highcharts.PointLabelObject) {
              return stateNameShortFormMap[this.point.name] || this.point.name;
            },
            style: {
              color: 'black',
              textOutline: 'none',
              fontWeight: 'normal',
            },
          },
          colorByPoint: true,
          states: {
            hover: {
              enabled: false,
              halo: {
                size: 0,
              },
              marker: {
                enabled: false,
              },
            },
          },
        },
      },
      series: [
        {
          name: 'Applicant States',
          data: applicantstateChartData,
        },
      ],
    };

    const applicantGenderData = apiData.ApplicantGenderData[0];

    chartsModel.applicantGenderData = {
      chart: {
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        type: 'pie',
        width: 350, // Adjust chart width
        height: 300, // Adjust chart height
      },
      title: {
        text: 'Applicant Distribution Gender Wise',
        align: 'left',
      },
      tooltip: {
        pointFormat: '{series.name}: <b>{point.y:.0f}</b>',
      },
      accessibility: {
        point: {
          valueSuffix: '',
        },
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: {
            enabled: false,
          },
          showInLegend: true,
        },
      },
      series: [
        {
          name: 'Gender',
          colorByPoint: true,
          data: [
            {
              name: 'Male',
              y: parseInt(applicantGenderData.maleCount),
              color: '#6fa8dc',
            },
            {
              name: 'Female',
              y: parseInt(applicantGenderData.femaleCount),
              color: '#d5a6bd',
            },
            {
              name: 'Other',
              y: parseInt(applicantGenderData.otherCount),
              color: '#cccccc',
            },
          ],
        },
      ],
    };

    const applicantregionData = apiData.ApplicantRegionData.map((region) => {
      return {
        name: region.region.charAt(0).toUpperCase() + region.region.slice(1),
        y: Number(region.regionApplicantCount),
      };
    });

    chartsModel.applicantRegionData = {
      chart: {
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        type: 'pie',
        width: 350, // Adjust chart width
        height: 300, // Adjust chart height
      },
      title: {
        text: 'Applicant Distribution Region Wise',
        align: 'left',
      },
      tooltip: {
        pointFormat: '{series.name}: <b>{point.y:.0f}</b>',
      },
      accessibility: {
        point: {
          valueSuffix: '',
        },
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: {
            enabled: false,
          },
          colors: ['#f3e0aa', '#a5e3bb', '#ffa4bf', '#9fc5e8'],
          showInLegend: true,
        },
      },
      series: [
        {
          name: 'Regions',
          colorByPoint: true,
          data: applicantregionData,
        },
      ],
    };

    const applicantbranchData = apiData.ApplicantBranchData.map((item) => [
      item.department_name,
      Number(item.branchApplicantCount),
    ]);

    chartsModel.applicantBranchData = {
      chart: {
        type: 'column',
        height: 320,
        backgroundColor: '#f0f0f0',
      },
      title: {
        text: 'Applicant Student Distribution Branch Wise',
      },
      xAxis: {
        type: 'category',
        labels: {
          // formatter: function () {
          //   let label = this.value;
          //   const maxLength = 10; // Maximum length before truncating
          //   if (label.length > maxLength) {
          //     const splitIndex = Math.ceil(label.length / 2);
          //     return label.substring(0, splitIndex) + "...";
          //   }
          //   return label;
          // },
          autoRotation: [-45, -90],
          style: {
            fontSize: '13px',
            fontFamily: 'Verdana, sans-serif',
          },
        },
      },
      yAxis: {
        min: 0,
        title: {
          text: 'Student Count',
        },
      },
      legend: {
        enabled: false,
      },
      tooltip: {
        pointFormat: 'Students: <b>{point.y:.0f} </b>',
      },
      series: [
        {
          name: 'Branch',
          colors: [
            '#9b20d9',
            '#9215ac',
            '#861ec9',
            '#7a17e6',
            '#7010f9',
            '#691af3',
            '#6225ed',
            '#5b30e7',
            '#533be1',
            '#4c46db',
            '#4551d5',
            '#3e5ccf',
            '#3667c9',
            '#2f72c3',
            '#277dbd',
            '#1f88b7',
            '#1693b1',
            '#0a9eaa',
            '#03c69b',
            '#00f194',
          ],
          colorByPoint: true,
          groupPadding: 0,
          data: applicantbranchData,
          dataLabels: {
            enabled: false,
            rotation: -90,
            color: '#FFFFFF',
            inside: true,
            verticalAlign: 'top',
            format: '{point.y:.1f}', // one decimal
            y: 10, // 10 pixels down from the top
            style: {
              fontSize: '11px',
              fontFamily: 'Verdana, sans-serif',
            },
          },
        },
      ],
    };

    //ssp hub
    chartsModel.sspHubAluminiChart = apiData.SSPHUBactiveStudentCount;
    // chartsModel.sspHubAluminiChart = apiData.SSPHUBactiveStudentCount;
    chartsModel.sSPHUBactiveStudentCount = apiData.SSPHUBactiveStudentCount;
    chartsModel.sSPHUBactiveStudentLoginCountDatewise =
      apiData.SSPHUBactiveStudentLoginCountDatewise;
    chartsModel.sSPHUBall_active_users_last_3_months_count =
      apiData.SSPHUBall_active_users_last_3_months_count;
    chartsModel.sSPHUBposts_last_3_months_count =
      apiData.SSPHUBposts_last_3_months_count;
    chartsModel.sSPHUBposts_last_3_months_count =
      apiData.SSPHUBposts_last_3_months_count;
    chartsModel.sSPHUBtotal_posts = apiData.SSPHUBtotal_posts;
    chartsModel.sSPHUBalumni_profile_updates_count =
      apiData.SSPHUBalumni_profile_updates_count;

    chartsModel.sspHubAluminiChart = {
      chart: {
        type: 'pie',
        height: 350,
        width: 450,
        custom: {},
        events: {
          render() {
            const chart: any = this,
              series = chart.series[0];
            let customLabel = chart.options.chart.custom.label;

            if (!customLabel) {
              customLabel = chart.options.chart.custom.label = chart.renderer
                .label(
                  'Total<br/>' +
                    '<strong>' +
                    apiData.SSPHUBalumniStudentCount +
                    '</strong>',
                )
                .css({
                  color: '#000',
                  textAnchor: 'middle',
                })
                .add();
            }

            const x = series.center[0] + chart.plotLeft,
              y =
                series.center[1] +
                chart.plotTop -
                customLabel.attr('height') / 2;

            customLabel.attr({
              x,
              y,
            });
            // Set font size based on chart diameter
            customLabel.css({
              fontSize: `${series.center[2] / 12}px`,
            });
          },
        },
      },
      accessibility: {
        point: {
          valueSuffix: '%',
        },
      },
      title: {
        text: 'Total Alumini Count',
        style: {
          fontSize: '17px', // Adjust the font size here
        },
      },
      tooltip: {
        // formatter: function () {
        //   // Display actual count in the tooltip
        //   return `<b>${this.point.name}</b>: ${Highcharts.numberFormat(
        //     this.point.y,
        //     0
        //   )}`;
        // },
      },
      legend: {
        enabled: true,
      },
      plotOptions: {
        series: {
          allowPointSelect: true,
          cursor: 'pointer',
          borderRadius: 8,
          dataLabels: [
            {
              enabled: true,
              distance: 20,
              format: '{point.name}',
            },
            {
              enabled: true,
              distance: -15,
              format: '{point.percentage:.0f}%',
              style: {
                fontSize: '0.9em',
              },
            },
          ],
          showInLegend: true,
        },
      },
      series: [
        {
          name: 'Registrations',
          colorByPoint: true,
          innerSize: '75%',
          data: [
            {
              name: 'Joined Alumini Count',
              y: parseInt(apiData.SSPHUBalumniJoinStudentCount),
              color: '#389388',
            },
            {
              name: 'Not Joined Alumini Count',
              y: parseInt(apiData.SSPHUBalumniNotJoinStudentCount),
              color: '#ffd2ce',
            },
          ],
        },
      ],
    };

    return chartsModel;
  }
}
